<template>
    <div>
        <tab name="7">{{id}} {{activityName}} <b  v-if="haveEditAudit" class="color-danger">存在还未处理的演出修改审核，请处理后再编辑演出信息</b></tab>        
       <el-tabs  type="border-card" v-model="tabValue">
           <el-tab-pane name="1">
               <span slot="label"><i class="el-icon-s-data"></i> 汇总统计</span>
               <template v-if="tabValue == '1'">
                   <lack-ticket-list :activityId="id" :activityName.sync="activityName" :haveEditAudit.sync="haveEditAudit"></lack-ticket-list>
               </template>    
           </el-tab-pane>
           <el-tab-pane name="2">
               <span slot="label"><i class="el-icon-time"></i> 分时统计</span>
               <template v-if="tabValue == '2'">
                   <lack-ticket-chart :activityId="id" :activityName.sync="activityName" :haveEditAudit.sync="haveEditAudit"></lack-ticket-chart>
               </template>
           </el-tab-pane>           
       </el-tabs>
		
    </div>
</template>

<script>
import Tab from '../components/tab';
import LackTicketList from './components/lack-ticket-list'
import LackTicketChart from './components/lack-ticket-chart'
export default {
    props:{
        id: {
            type: [Number, String],
            default: () => null
        }
    },
    components:{
        Tab,LackTicketList,LackTicketChart
    },
    data(){
        return{
            activityName:'',
            haveEditAudit: false,
            redirect: this.$route.query.redirect,           
			tabValue: "1",
           
        }
    },
    methods:{
       
    }
}
</script>